<body>
    <section>
        <div class="div-center">
            <div class="buzz-logo">
                <img src="../../assets/images/loading-buzz-logo.png" alt="" srcset="">
            </div>

            <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="25" aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" [style.width.%]="progress"></div>
            </div>
        </div>
    </section>

</body>
    